var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.token)?_c('NavbarComponent'):_vm._e(),(_vm.token)?_c('SidebarComponent'):_vm._e(),_c('ContentComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }